/**
 * Breaking News color palette — shared between the admin editor and the public
 * `<BreakingNewsBar />`. Each entry defines:
 *  - key     : DB-persisted identifier (stable, DO NOT rename existing keys)
 *  - label   : human-readable Italian name shown in admin
 *  - dark    : deepest brand shade — used for solid CTA text/button color
 *  - mid     : mid brand shade      — dominant gradient stop
 *  - light   : lightest highlight   — top-end of the gradient
 *  - shadow  : rgba drop-shadow tint matching the mid shade
 */
export const BREAKING_NEWS_COLORS = [
  { key: "pink",    label: "Fuxia",     dark: "#b81f8d", mid: "#ff4fcf", light: "#ff80df", shadow: "rgba(255, 79, 207, 0.55)" },
  { key: "red",     label: "Rosso",     dark: "#7f1d1d", mid: "#ef4444", light: "#fca5a5", shadow: "rgba(239, 68, 68, 0.55)" },
  { key: "orange",  label: "Arancio",   dark: "#9a3412", mid: "#f97316", light: "#fdba74", shadow: "rgba(249, 115, 22, 0.55)" },
  { key: "amber",   label: "Ambra",     dark: "#92400e", mid: "#f59e0b", light: "#fcd34d", shadow: "rgba(245, 158, 11, 0.55)" },
  { key: "yellow",  label: "Giallo",    dark: "#854d0e", mid: "#C2410C", light: "#EA580C", shadow: "rgba(234, 179, 8, 0.55)" },
  { key: "lime",    label: "Lime",      dark: "#365314", mid: "#84cc16", light: "#bef264", shadow: "rgba(132, 204, 22, 0.55)" },
  { key: "emerald", label: "Verde",     dark: "#064e3b", mid: "#10b981", light: "#6ee7b7", shadow: "rgba(16, 185, 129, 0.55)" },
  { key: "teal",    label: "Teal",      dark: "#134e4a", mid: "#14b8a6", light: "#5eead4", shadow: "rgba(20, 184, 166, 0.55)" },
  { key: "cyan",    label: "Ciano",     dark: "#155e75", mid: "#06b6d4", light: "#67e8f9", shadow: "rgba(6, 182, 212, 0.55)" },
  { key: "blue",    label: "Blu",       dark: "#1e40af", mid: "#3b82f6", light: "#93c5fd", shadow: "rgba(59, 130, 246, 0.55)" },
  { key: "indigo",  label: "Indaco",    dark: "#3730a3", mid: "#6366f1", light: "#a5b4fc", shadow: "rgba(99, 102, 241, 0.55)" },
  { key: "violet",  label: "Viola",     dark: "#5b21b6", mid: "#8b5cf6", light: "#c4b5fd", shadow: "rgba(139, 92, 246, 0.55)" },
];

export const DEFAULT_BREAKING_NEWS_COLOR = "pink";

/** Look up a palette entry by key, falling back to the default. */
export function getBreakingNewsColor(key) {
  return (
    BREAKING_NEWS_COLORS.find((c) => c.key === key) ||
    BREAKING_NEWS_COLORS.find((c) => c.key === DEFAULT_BREAKING_NEWS_COLOR)
  );
}
